import React from 'react';
import {Alert, Button, Modal} from "antd";
import {injectIntl} from "react-intl";
import Constants from "../../../services/Constants";
import {getDayNameOutOfDate, isAtNoonOrAfternoon, isBeforeOrAtNoon} from "../../../helpers/planning";

class ChangeMonthDayStatus extends React.Component {
  state = {
    isBlockDaySelected: false,
    isCloseDaySelected: false,

    isAMSelected: false,
    isPMSelected: false,

    isAllAMSelected: false,
    isBlockWaitingAMSelected: false,
    isBlockNonWaitingAMSelected: false,

    isAllPMSelected: false,
    isBlockWaitingPMSelected: false,
    isBlockNonWaitingPMSelected: false,

    isCloseDayAMSelected: false,
    isCloseDayPMSelected: false,

    reset: false,
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.date && (JSON.stringify(prevProps.date) !== JSON.stringify(this.props.date))) {
      this.setState(this.translatePayloadToState(this.props.date, this.props.planning));
    } else if (this.state.reset && JSON.stringify(this.translatePayloadToState(this.props.date, this.props.planning) !== JSON.stringify(this.state))) {
      this.setState(this.translatePayloadToState(this.props.date, this.props.planning));
    }
  }

  /**
 * Validates the state according to the given constraints.
 */
  validateState = () =>  {
    const {
        isAMSelected, isAllAMSelected, isBlockWaitingAMSelected, isBlockNonWaitingAMSelected,
        isPMSelected, isAllPMSelected, isBlockWaitingPMSelected, isBlockNonWaitingPMSelected,
        isCloseDayAMSelected, isCloseDayPMSelected, isCloseDaySelected, isBlockDaySelected
    } = this.state;

    // Constraint 1: Only one of isAllAMSelected, isBlockWaitingAMSelected and isBlockNonWaitingAMSelected can be true only when isAMSelected is true
    if (isAMSelected) {
        const amCount = [isAllAMSelected, isBlockWaitingAMSelected, isBlockNonWaitingAMSelected].filter(Boolean).length;
        if (amCount !== 1) return false;
    }

    // Constraint 2: Only one of isAllPMSelected, isBlockWaitingPMSelected and isBlockNonWaitingPMSelected can be true only when isPMSelected is true
    if (isPMSelected) {
        const pmCount = [isAllPMSelected, isBlockWaitingPMSelected, isBlockNonWaitingPMSelected].filter(Boolean).length;
        if (pmCount !== 1) return false;
    }

    // Constraint 3: isAMSelected and isCloseDayAMSelected can never be true at the same time and isPMSelected and isCloseDayPMSelected can never be true at the same time
    if ((isAMSelected && isCloseDayAMSelected) || (isPMSelected && isCloseDayPMSelected)) {
        return false;
    }

    // Constraint 4: isAMSelected and isPMSelected can never be true when isBlockDaySelected is true
    if (isBlockDaySelected && (isAMSelected || isPMSelected)) {
      return false;
    }

    // Constraint 5: isCloseDaySelected can never be true when isCloseDayAMSelected or isCloseDayPMSelected is true
    if (isCloseDaySelected && (isCloseDayAMSelected || isCloseDayPMSelected)) {
      return false;
    }

    // Constraint 6: isCloseDaySelected can never be true when isBlockDaySelected is true
    if (isCloseDaySelected && isBlockDaySelected) {
      return false;
    }

    // If none of the constraints were violated, the state is valid
    return true;
  }

  // Function to translate the payload to state when reopening the modal
  translatePayloadToState = (payload, planning) => {

    const dayName = getDayNameOutOfDate(payload.day).toUpperCase();
    const dayPlanning = planning ? planning[dayName] : null;
    const dayPlanningSlots = dayPlanning ? dayPlanning.slots : [];
    const hasAmSlots = dayPlanningSlots.some(slots => isBeforeOrAtNoon(slots.endTime));
    const hasPmSlots = dayPlanningSlots.some(slots => isAtNoonOrAfternoon(slots.startTime));
  // Initialize the new state object
  const newState = {
    isBlockDaySelected: false,
    isCloseDaySelected: false,

    isAMSelected: false,
    isPMSelected: false,

    isAllAMSelected: false,
    isBlockWaitingAMSelected: false,
    isBlockNonWaitingAMSelected: false,

    isAllPMSelected: false,
    isBlockWaitingPMSelected: false,
    isBlockNonWaitingPMSelected: false,

    isCloseDayAMSelected: false,
    isCloseDayPMSelected: false,

    reset: false,
  };

  // Check the payload values and update the new state accordingly
  if (payload.dayStatus === Constants.DAY_OPEN.value) {
    newState.isAMSelected = false;
    newState.isPMSelected = false;
    newState.isAllAMSelected = false;
    newState.isAllPMSelected = false;
  } else if (payload.dayStatus === Constants.DAY_CLOSED.value) {
    if (!payload.amStatus && !payload.pmStatus) {
      if (!hasAmSlots || !hasPmSlots) {
        newState.isCloseDaySelected = true;
      } else {
        newState.isCloseDayAMSelected = true;
        newState.isCloseDayPMSelected = true;
      }
    } else if (payload.amStatus === Constants.DAY_CLOSED_AM.value) {
      newState.isCloseDayAMSelected = true;
    } else if (payload.pmStatus === Constants.DAY_CLOSED_PM.value) {
      newState.isCloseDayPMSelected = true;
    }
  } else if (payload.dayStatus === Constants.DAY_OVERBOOKED.value) {
    if (payload.amStatus === Constants.DAY_BLOCK_AM.value) {
      newState.isAMSelected = true;
      if (payload.amExtendedStatus === Constants.DAY_CONSTRAINT_BLOCK_WAIT_AM.value) {
        newState.isBlockWaitingAMSelected = true;
      } else if (payload.amExtendedStatus === Constants.DAY_CONSTRAINT_BLOCK_NON_WAIT_AM.value) {
        newState.isBlockNonWaitingAMSelected = true;
      } else {
        newState.isAllAMSelected = true;
      }
    }
    if (payload.pmStatus === Constants.DAY_BLOCK_PM.value) {
      newState.isPMSelected = true;
      if (payload.pmExtendedStatus === Constants.DAY_CONSTRAINT_BLOCK_WAIT_PM.value) {
        newState.isBlockWaitingPMSelected = true;
      } else if (payload.pmExtendedStatus === Constants.DAY_CONSTRAINT_BLOCK_NON_WAIT_PM.value) {
        newState.isBlockNonWaitingPMSelected = true;
      } else {
        newState.isAllPMSelected = true;
      }
    }

    if (!payload.amStatus && !payload.pmStatus) {
      newState.isBlockDaySelected = true;
    }
  } else if (payload.dayStatus === Constants.DAY_MIXED.value) {
    if (payload.amStatus === Constants.DAY_BLOCK_AM.value) {
      newState.isAMSelected = true;
      if (payload.amExtendedStatus === Constants.DAY_CONSTRAINT_BLOCK_WAIT_AM.value) {
        newState.isBlockWaitingAMSelected = true;
      } else if (payload.amExtendedStatus === Constants.DAY_CONSTRAINT_BLOCK_NON_WAIT_AM.value) {
        newState.isBlockNonWaitingAMSelected = true;
      } else {
        newState.isAllAMSelected = true;
      }
    } else {
      newState.isCloseDayAMSelected = true;
    }
    if (payload.pmStatus === Constants.DAY_BLOCK_PM.value) {
      newState.isPMSelected = true;
      if (payload.pmExtendedStatus === Constants.DAY_CONSTRAINT_BLOCK_WAIT_PM.value) {
        newState.isBlockWaitingPMSelected = true;
      } else if (payload.pmExtendedStatus === Constants.DAY_CONSTRAINT_BLOCK_NON_WAIT_PM.value) {
        newState.isBlockNonWaitingPMSelected = true;
      } else {
        newState.isAllPMSelected = true;
      }
    } else {
      newState.isCloseDayPMSelected = true;
    }

  }

  // Return the new state
  return newState;
};

  get isAnyCloseSelected() {
    return this.state.isCloseDayAMSelected || this.state.isCloseDayPMSelected || this.state.isCloseDaySelected;
  }
  get isAnyCloseSelectedExceptAM() {
    return this.state.isCloseDayPMSelected || this.state.isCloseDaySelected;
  }

  get isAnyCloseSelectedExceptPM() {
    return this.state.isCloseDayAMSelected || this.state.isCloseDaySelected;
  }

  get isClosedHalfDay() {
    return this.state.isCloseDayAMSelected || this.state.isCloseDayPMSelected;
  }

  get isAnyBlockSelected() {
    return this.state.isAMSelected || this.state.isPMSelected || this.state.isBlockDaySelected;
  }

  get isBlockedHalfDay() {
    return this.state.isAMSelected || this.state.isPMSelected;
  }

  onSave = () => {
    const {date, onModalClose, onModalDayChange} = this.props;

    const isOpen = Object.values(this.state).every(value => value === false);

    const payload = {
      currentInterventions: date.nbInterventions,
      dayStatus: null,
      amStatus: null,
      pmStatus: null,
      amExtendedStatus: null,
      pmExtendedStatus: null,
    };

    if (isOpen) {
      payload.dayStatus = Constants.DAY_OPEN.OPEN;
    } else if (this.state.isBlockDaySelected) {
      payload.dayStatus = Constants.DAY_OVERBOOKED.value;
    }  else if (this.state.isCloseDaySelected) {
      payload.dayStatus = Constants.DAY_CLOSED.value;
    } else if (!this.state.isAMSelected && !this.state.isPMSelected) {
      if (this.state.isCloseDayAMSelected && !this.state.isCloseDayPMSelected) {
        payload.dayStatus = Constants.DAY_CLOSED.value;
        payload.amStatus = Constants.DAY_CLOSED_AM.value;
      } else if (this.state.isCloseDayPMSelected && !this.state.isCloseDayAMSelected) {
        payload.dayStatus = Constants.DAY_CLOSED.value;
        payload.pmStatus = Constants.DAY_CLOSED_PM.value;
      } else if (this.state.isCloseDayAMSelected && this.state.isCloseDayPMSelected) {
        payload.dayStatus = Constants.DAY_CLOSED.value;
      }
    } else if (!this.state.isCloseDayAMSelected && !this.state.isCloseDayPMSelected) {
      if (this.state.isAMSelected && this.state.isPMSelected && this.state.isAllAMSelected && this.state.isAllPMSelected) {
        payload.dayStatus = Constants.DAY_OVERBOOKED.value;
        payload.amStatus = Constants.DAY_BLOCK_AM.value;
        payload.pmStatus = Constants.DAY_BLOCK_PM.value;
      } else {
        if (this.state.isAMSelected) {
          payload.dayStatus = Constants.DAY_OVERBOOKED.value;
          payload.amStatus = Constants.DAY_BLOCK_AM.value;
          if (this.state.isBlockWaitingAMSelected) {
            payload.amExtendedStatus = Constants.DAY_CONSTRAINT_BLOCK_WAIT_AM.value;
          } else if (this.state.isBlockNonWaitingAMSelected) {
            payload.amExtendedStatus = Constants.DAY_CONSTRAINT_BLOCK_NON_WAIT_AM.value;
          }
        }
        if (this.state.isPMSelected) {
          payload.dayStatus = Constants.DAY_OVERBOOKED.value;
          payload.pmStatus = Constants.DAY_BLOCK_PM.value;
          if (this.state.isBlockWaitingPMSelected) {
            payload.pmExtendedStatus = Constants.DAY_CONSTRAINT_BLOCK_WAIT_PM.value;
          } else if (this.state.isBlockNonWaitingPMSelected) {
            payload.pmExtendedStatus = Constants.DAY_CONSTRAINT_BLOCK_NON_WAIT_PM.value;
          }
        }
      }
    } else {
      payload.dayStatus = Constants.DAY_MIXED.value;
      if (this.state.isAMSelected) {
        payload.amStatus = Constants.DAY_BLOCK_AM.value;
        if (this.state.isBlockWaitingAMSelected) {
          payload.amExtendedStatus = Constants.DAY_CONSTRAINT_BLOCK_WAIT_AM.value;
        } else if (this.state.isBlockNonWaitingAMSelected) {
          payload.amExtendedStatus = Constants.DAY_CONSTRAINT_BLOCK_NON_WAIT_AM.value;
        }
      } else if (this.state.isCloseDayAMSelected) {
        payload.amStatus = Constants.DAY_CLOSED_AM.value;
      }
      if (this.state.isPMSelected) {
        payload.pmStatus = Constants.DAY_BLOCK_PM.value;
        if (this.state.isBlockWaitingPMSelected) {
          payload.pmExtendedStatus = Constants.DAY_CONSTRAINT_BLOCK_WAIT_PM.value;
        } else if (this.state.isBlockNonWaitingPMSelected) {
          payload.pmExtendedStatus = Constants.DAY_CONSTRAINT_BLOCK_NON_WAIT_PM.value;
        }
      } else if (this.state.isCloseDayPMSelected) {
        payload.pmStatus = Constants.DAY_CLOSED_PM.value;
      }
    }

    onModalClose();
    onModalDayChange(date.day, payload);
  }

  onCancel = () => {
    this.props.onModalClose();
    this.setState({
      isBlockDaySelected: false,
      isCloseDaySelected: false,

      isAMSelected: false,
      isPMSelected: false,

      isAllAMSelected: false,
      isBlockWaitingAMSelected: false,
      isBlockNonWaitingAMSelected: false,

      isAllPMSelected: false,
      isBlockWaitingPMSelected: false,
      isBlockNonWaitingPMSelected: false,

      isCloseDayAMSelected: false,
      isCloseDayPMSelected: false,

      reset: true,
    });
  }

  onSelectBlockAM = () => {
    if (this.state.isAMSelected) {
      this.setState({
        ...this.state,
        isAMSelected: false,
        isAllAMSelected: false,
        isBlockWaitingAMSelected: false,
        isBlockNonWaitingAMSelected: false
      });
    } else {
      this.setState({
        ...this.state,
        isAMSelected: true,
        isAllAMSelected: true,
        isBlockWaitingAMSelected: false,
        isBlockNonWaitingAMSelected: false
      });
    }
  }

  onSelectBlockPM = () => {
    if (this.state.isPMSelected) {
      this.setState({
        ...this.state,
        isPMSelected: false,
        isAllPMSelected: false,
        isBlockWaitingPMSelected: false,
        isBlockNonWaitingPMSelected: false
      });
    } else {
      this.setState({
        ...this.state,
        isPMSelected: true,
        isAllPMSelected: true,
        isBlockWaitingPMSelected: false,
        isBlockNonWaitingPMSelected: false
      });
    }
  }

  onSelectBlockAllAM = () => {
    if (!this.state.isAllAMSelected && this.state.isAMSelected) {
      this.setState({
        ...this.state,
        isAllAMSelected: true,
        isBlockWaitingAMSelected: false,
        isBlockNonWaitingAMSelected: false
      });
    }
  }

  onSelectBlockAllPM = () => {
    if (!this.state.isAllPMSelected && this.state.isPMSelected) {
      this.setState({
        ...this.state,
        isAllPMSelected: true,
        isBlockWaitingPMSelected: false,
        isBlockNonWaitingPMSelected: false
      });
    }
  }

  onSelectBlockWaitingAM = () => {
    if (!this.state.isBlockWaitingAMSelected && this.state.isAMSelected) {
      this.setState({
        ...this.state,
        isAllAMSelected: false,
        isBlockWaitingAMSelected: true,
        isBlockNonWaitingAMSelected: false
      });
    }
  }

  onSelectBlockWaitingPM = () => {
    if (!this.state.isBlockWaitingPMSelected && this.state.isPMSelected) {
      this.setState({
        ...this.state,
        isAllPMSelected: false,
        isBlockWaitingPMSelected: true,
        isBlockNonWaitingPMSelected: false
      });
    }
  }

  onSelectBlockNonWaitingAM = () => {
    if (!this.state.isBlockNonWaitingAMSelected && this.state.isAMSelected) {
      this.setState({
        ...this.state,
        isAllAMSelected: false,
        isBlockWaitingAMSelected: false,
        isBlockNonWaitingAMSelected: true
      });
    }
  }

  onSelectBlockNonWaitingPM = () => {
    if (!this.state.isBlockNonWaitingPMSelected && this.state.isPMSelected) {
      this.setState({
        ...this.state,
        isAllPMSelected: false,
        isBlockWaitingPMSelected: false,
        isBlockNonWaitingPMSelected: true
      });
    }
  }

  onSelectBlockFullDay = () => {
    this.setState({
      isBlockDaySelected: !this.state.isBlockDaySelected,
      isCloseDaySelected: false,
      isAMSelected: false,
      isPMSelected: false,
      isAllAMSelected: false,
      isBlockWaitingAMSelected: false,
      isBlockNonWaitingAMSelected: false,
      isAllPMSelected: false,
      isBlockWaitingPMSelected: false,
      isBlockNonWaitingPMSelected: false,
      isCloseDayAMSelected: false,
      isCloseDayPMSelected: false,
    });
  }

  onSelectCloseFullDay = () => {
    this.setState({
      isCloseDaySelected: !this.state.isCloseDaySelected,
      isBlockDaySelected: false,
      isAMSelected: false,
      isPMSelected: false,
      isAllAMSelected: false,
      isBlockWaitingAMSelected: false,
      isBlockNonWaitingAMSelected: false,
      isAllPMSelected: false,
      isBlockWaitingPMSelected: false,
      isBlockNonWaitingPMSelected: false,
      isCloseDayAMSelected: false,
      isCloseDayPMSelected: false,
    });
  }

  onSelectCloseDayAM = () => {
    if (this.state.isCloseDayAMSelected) {
      this.setState({
        ...this.state,
        isCloseDayAMSelected: false,
      });
    } else {
      this.setState({
        ...this.state,
        isCloseDayAMSelected: true,
        isAMSelected: false,
        isAllAMSelected: false,
        isBlockWaitingAMSelected: false,
        isBlockNonWaitingAMSelected: false
      });
    }
  }

  onSelectCloseDayPM = () => {
    if (this.state.isCloseDayPMSelected) {
      this.setState({
        ...this.state,
        isCloseDayPMSelected: false,
      });
    } else {
      this.setState({
        ...this.state,
        isCloseDayPMSelected: true,
        isPMSelected: false,
        isAllPMSelected: false,
        isBlockWaitingPMSelected: false,
        isBlockNonWaitingPMSelected: false
      });
    }
  }

  generateErrorMessage = () => {
    if (!this.validateState()) {
      return 'month-planning.status-change.error';
    }
    return 'month-planning.status-change.no-slots';
  };

  buttonStatus = (selected, message, disabled, date, onClick) => (
    <Button className={selected ? 'day-status-btn-selected' : 'day-status-btn'} style={{paddingLeft: 32, paddingRight: 32}} disabled={disabled} onClick={onClick}>{message}</Button>
  )

  renderBlockAM = (date, canBeBlocked, formatMessage, hasAmSlots) => (
      <div className="day-status-section">
        {this.buttonStatus(this.state.isAMSelected, formatMessage({id:'month-planning.action.am', defaultMessage: 'AM'}), !canBeBlocked || this.isAnyCloseSelectedExceptPM || this.state.isBlockDaySelected || !hasAmSlots, date, this.onSelectBlockAM)}
        <div className="day-status-vertical-separator" />
        {this.buttonStatus(this.state.isAllAMSelected, formatMessage({id:'month-planning.action.all', defaultMessage: 'All'}), !canBeBlocked || !this.state.isAMSelected, date, this.onSelectBlockAllAM)}
        {this.buttonStatus(this.state.isBlockWaitingAMSelected, formatMessage({id:'month-planning.action.waiting', defaultMessage: 'Waiting'}), !canBeBlocked || !this.state.isAMSelected, date, this.onSelectBlockWaitingAM)}
        {this.buttonStatus(this.state.isBlockNonWaitingAMSelected, formatMessage({id:'month-planning.action.not-waiting', defaultMessage: 'Non-waiting'}), !canBeBlocked || !this.state.isAMSelected, date, this.onSelectBlockNonWaitingAM)}
      </div>
  );

  renderBlockPM = (date, canBeBlocked, formatMessage, hasPmSlots) => (
      <div className="day-status-section">
        {this.buttonStatus(this.state.isPMSelected, formatMessage({id:'month-planning.action.pm', defaultMessage: 'PM'}), !canBeBlocked || this.isAnyCloseSelectedExceptAM || this.state.isBlockDaySelected || !hasPmSlots, date, this.onSelectBlockPM)}
        <div className="day-status-vertical-separator" />
        {this.buttonStatus(this.state.isAllPMSelected, formatMessage({id:'month-planning.action.all', defaultMessage: 'All'}), !canBeBlocked || !this.state.isPMSelected, date, this.onSelectBlockAllPM)}
        {this.buttonStatus(this.state.isBlockWaitingPMSelected, formatMessage({id:'month-planning.action.waiting', defaultMessage: 'Waiting'}), !canBeBlocked || !this.state.isPMSelected, date, this.onSelectBlockWaitingPM)}
        {this.buttonStatus(this.state.isBlockNonWaitingPMSelected, formatMessage({id:'month-planning.action.not-waiting', defaultMessage: 'Non-waiting'}), !canBeBlocked || !this.state.isPMSelected, date, this.onSelectBlockNonWaitingPM)}
      </div>
  );

  renderCloseDay = (date, canBeOpen, formatMessage, hasAmSlots, hasPmSlots) => (
      <div className="day-status-section">
        {hasAmSlots && this.buttonStatus(this.state.isCloseDayAMSelected, formatMessage({id:'month-planning.action.close-am', defaultMessage: 'AM'}), !canBeOpen || this.state.isAMSelected || this.state.isBlockDaySelected || this.state.isCloseDaySelected, date, this.onSelectCloseDayAM)}
        {hasPmSlots && this.buttonStatus(this.state.isCloseDayPMSelected, formatMessage({id:'month-planning.action.close-pm', defaultMessage: 'PM'}), !canBeOpen || this.state.isPMSelected || this.state.isBlockDaySelected || this.state.isCloseDaySelected, date, this.onSelectCloseDayPM)}
      </div>
  );

  renderBlockFullDay = (date, canBeBlocked, formatMessage) => (
      <div className="day-status-section">
        {this.buttonStatus(this.state.isBlockDaySelected, formatMessage({id:'month-planning.action.block', defaultMessage: 'Block day'}), !canBeBlocked || this.isBlockedHalfDay || this.isAnyCloseSelected, date, this.onSelectBlockFullDay)}
      </div>
  );

  renderCloseFullDay = (date, canBeClosed, formatMessage) => (
      <div className="day-status-section">
        {this.buttonStatus(this.state.isCloseDaySelected, formatMessage({id:'month-planning.action.close', defaultMessage: 'Close day'}), !canBeClosed || this.isClosedHalfDay || this.isAnyBlockSelected, date, this.onSelectCloseFullDay)}
      </div>
  );

  renderBlock = (date, canBeBlocked, formatMessage, hasAmSlots, hasPmSlots) => (
    <React.Fragment>
      <div className="day-status-section-title">{formatMessage({id:'month-planning.action.block', defaultMessage: 'Block day'})}</div>
      {this.renderBlockAM(date, canBeBlocked, formatMessage, hasAmSlots)}
      {this.renderBlockPM(date, canBeBlocked, formatMessage, hasPmSlots)}
      {this.renderBlockFullDay(date, canBeBlocked, formatMessage)}
      <div className="day-status-section-separator" />
    </React.Fragment>
  );

  renderClose = (date, canBeClosed, formatMessage, hasAmSlots, hasPmSlots) => (
    <React.Fragment>
      <div className="day-status-section-title">{formatMessage({id:'month-planning.action.close', defaultMessage: 'Close day'})}</div>
      {this.renderCloseDay(date, canBeClosed, formatMessage, hasAmSlots, hasPmSlots)}
      {(!hasAmSlots || !hasPmSlots) && this.renderCloseFullDay(date, canBeClosed, formatMessage)}
      <div className="day-status-section-separator" />
    </React.Fragment>
  );

  renderFooter = (formatMessage, hasError) => {
    return (
      <React.Fragment>
        <div className="day-status-warning">
          <Alert message={formatMessage({id: 'month-planning.action.warning-save'})} type="warning"/>
        </div>
        <div className="day-status-footer-block">
          <Button type="primary" disabled={hasError} onClick={this.onSave}>{formatMessage({id: 'action.ok'})}</Button>
        </div>
      </React.Fragment>
    );
  }

  render() {
    const {intl:{formatMessage}, visible, date, computeAll, planning} = this.props;
    const totalOngoingInterventions = computeAll(date.day);

    const dayName = getDayNameOutOfDate(date.day).toUpperCase();
    const dayPlanning = planning ? planning[dayName] : null;
    const dayPlanningSlots = dayPlanning ? dayPlanning.slots : [];
    const hasAmSlots = dayPlanningSlots.some(slots => isBeforeOrAtNoon(slots.endTime));
    const hasPmSlots = dayPlanningSlots.some(slots => isAtNoonOrAfternoon(slots.startTime));
    const canBeClosed = totalOngoingInterventions <= 0 && date.maxInterventions > 0;
    const canBeBlocked = date.maxInterventions > 0;
    const canBeOpen = date.dayStatus;
    const hasError = (!canBeClosed && !canBeBlocked && !canBeOpen) || !this.validateState();
    const isFullyBooked = totalOngoingInterventions > 0 && date.maxInterventions > 0 && totalOngoingInterventions >= date.maxInterventions;


    return (
      <div>
        <Modal
          title={formatMessage({id: 'section.month-planning.modal.title'})}
          visible={visible}
          footer={null}
          onCancel={this.onCancel}
          style={{minWidth: 550}}
        >
          <div className="day-status-block">
            {this.isAnyBlockSelected && <Alert message={formatMessage({id: 'month-planning.action.warning-block'})} type="warning" />}
            <label className="day-status">{formatMessage({id: `month-planning.action.${totalOngoingInterventions ? 'total-appointments-planned' : 'no-appointment-planned'}`}, {totalIntervention: totalOngoingInterventions})}</label>
            {isFullyBooked && <label className="txt-warn">{formatMessage({id: 'month-planning.status-change.no-place'})}</label>}
            <div className="day-status-section-separator" />
            {this.renderBlock(date, canBeBlocked, formatMessage, hasAmSlots, hasPmSlots)}
            {this.renderClose(date, canBeClosed, formatMessage, hasAmSlots, hasPmSlots)}
            {hasError &&
              <React.Fragment>
                <label className="day-status-error">{formatMessage({id: this.generateErrorMessage()})}</label>
                <div className="day-status-section-separator"/>
              </React.Fragment>
            }
            {this.renderFooter(formatMessage, hasError)}
          </div>
        </Modal>
      </div>
    )
  }
}

export default injectIntl(ChangeMonthDayStatus);
